import React, { useState, useEffect } from "react";

const BooksNavbar = ({ textColor = "white" }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  // useEffect(() => {
  //   document.title = "Think Before You Think";

  //   const favicon = document.getElementById("dynamic-favicon");
  //   if (favicon) {
  //     favicon.setAttribute("href", "/books-icon-favicon.png");
  //   }
  // }, []);

  useEffect(() => {
  document.title = "Think Before You Think";

  const oldFavicon = document.getElementById("dynamic-favicon");
  if (oldFavicon) {
    oldFavicon.remove();
  }

  const newFavicon = document.createElement("link");
  newFavicon.id = "dynamic-favicon";
  newFavicon.rel = "icon";
  newFavicon.type = "image/png";
  newFavicon.href = "/books-icon-favicon.png";

  document.head.appendChild(newFavicon);
}, []);

  return (
    <nav
      className={`absolute top-0 left-0 right-0 z-50 px-6 py-4 ${textColor === "white" ? "text-white" : "text-black"}`}
    >
      <div className="flex justify-between items-center max-w-7xl mx-auto w-full px-4">
        {/* <div className="font-semibold text-lg">
          THINK BEFORE YOU THINK
        </div> */}
        <a href="/books" className="font-semibold text-lg">
          THINK BEFORE YOU THINK
        </a>

        <div className="hidden md:flex items-center space-x-4 text-sm">
          {/* <a href="/books">THE BOOK</a> */}
          <a
            href="https://wwnorton.com/books/9781324075165"
            target="_blank"
            rel="noopener noreferrer"
            // className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
          >
            THE BOOK
          </a>
          <a href="/books/science">THE SCIENCE</a>
          <a href="/books/about">ABOUT ADRIAN</a>
          <a href="/books/news">NEWS</a>
          <a href="/books/contact">CONTACT</a>
          <a href="/">OWENLAB</a>

          <a
            href="https://wwnorton.com/books/9781324075165"
            target="_blank"
            rel="nooperner noreferrer"
            className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
          >
            ORDER
          </a>
        </div>

        <button
          className="md:hidden text-black text-2xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ≡
        </button>
      </div>

      {menuOpen && (
        <div className="absolute top-full left-0 w-full bg-black text-white flex flex-col items-center py-4 space-y-4 md:hidden">
          {/* <a href="/books">THE BOOK</a> */}
          <a
            href="https://wwnorton.com/books/9781324075165"
            target="_blank"
            rel="nooperner noreferrer"
            // className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
          >
            THE BOOK
          </a>
          <a href="/books/science">THE SCIENCE</a>
          <a href="/books/about">ABOUT ADRIAN</a>
          <a href="/books/news">NEWS</a>
          <a href="/books/contact">CONTACT</a>
          <a href="/">OWENLAB</a>

          <a
            href="https://wwnorton.com/books/9781324075165"
            target="_blank"
            rel="nooperner noreferrer"
            className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
          >
            PREORDER
          </a>
        </div>
      )}
    </nav>
  );
};

export default BooksNavbar;
